"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RequestAccess = exports.RequestAccessModal = exports.default = void 0;

var _base = require("./base");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _noty = require("noty");

var _react = _interopRequireWildcard(require("react"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _decorators = require("decorators");

var _userProfile = require("user-profile");

var _class, _descriptor;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || babelHelpers.typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = babelHelpers.getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = babelHelpers.getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return babelHelpers.possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EmailValidatorRegex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

var RequestAccessModal = /*#__PURE__*/function (_ReactModal) {
  babelHelpers.inherits(RequestAccessModal, _ReactModal);

  var _super = _createSuper(RequestAccessModal);

  function RequestAccessModal() {
    var _this;

    babelHelpers.classCallCheck(this, RequestAccessModal);
    _this = _super.call(this);
    _this.classList = ['modal', 'modal-full', 'fade', 'survey-modal', 'request-access-modal'];
    _this.modalTitleElement = 'h3';
    _this.withError = false;
    _this.defaultType = null;
    _this.removeOnHide = true;

    _this.setComponent( /*#__PURE__*/_react.default.createElement(RequestAccess, {
      modal: babelHelpers.assertThisInitialized(_this)
    }));

    return _this;
  }

  babelHelpers.createClass(RequestAccessModal, [{
    key: "title",
    get: function get() {
      return "";
    }
  }]);
  return RequestAccessModal;
}(_base.ReactModal);

exports.RequestAccessModal = RequestAccessModal;
var RequestAccess = (_class = /*#__PURE__*/function (_Component) {
  babelHelpers.inherits(RequestAccess, _Component);

  var _super2 = _createSuper(RequestAccess);

  function RequestAccess() {
    var _this2;

    babelHelpers.classCallCheck(this, RequestAccess);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this2, "modal", _descriptor, babelHelpers.assertThisInitialized(_this2));
    _this2.state = {
      name: '',
      phone: '',
      email: '',
      facility: '',
      comments: '',
      status: 'form'
    };
    return _this2;
  }

  babelHelpers.createClass(RequestAccess, [{
    key: "fieldChanged",
    value: function fieldChanged(event) {
      this.setState(babelHelpers.defineProperty({}, event.target.name, event.target.value));
    }
  }, {
    key: "submit",
    value: function submit(event) {
      var _this3 = this;

      event.preventDefault();
      this.setState({
        status: 'submit'
      }, function () {
        var _this3$state = _this3.state,
            name = _this3$state.name,
            phone = _this3$state.phone,
            email = _this3$state.email,
            facility = _this3$state.facility,
            comments = _this3$state.comments;
        (0, _fetch.default)('data/request-access', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            name: name,
            phone: phone,
            email: email,
            facility: facility,
            comments: comments
          })
        }).then(function (r) {
          return r.text();
        }).then(function (r) {
          _this3.setState({
            status: 'complete'
          });
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var state = this.state;

      if (state.status == 'complete') {
        return /*#__PURE__*/_react.default.createElement("form", {
          className: "side-nav-main",
          onSubmit: function onSubmit(event) {
            var _this4$modal;

            (_this4$modal = _this4.modal) === null || _this4$modal === void 0 ? void 0 : _this4$modal.hide();
            event.preventDefault();
          }
        }, /*#__PURE__*/_react.default.createElement("h3", null, "Request Access to The Pool & Spa House ProSite"), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("p", null, "Thank you for your submission!", /*#__PURE__*/_react.default.createElement("br", null), "We will be in contact with you soon!"), /*#__PURE__*/_react.default.createElement("hr", null), this.modal ? /*#__PURE__*/_react.default.createElement("div", {
          className: "form-action center-block"
        }, /*#__PURE__*/_react.default.createElement("button", {
          type: "submit",
          className: "btn btn-primary"
        }, "Close")) : null);
      }

      return /*#__PURE__*/_react.default.createElement("form", {
        method: "post",
        role: "form",
        className: "side-nav-main",
        onSubmit: this.submit
      }, /*#__PURE__*/_react.default.createElement("h3", null, "Request Access to The Pool & Spa House ProSite"), /*#__PURE__*/_react.default.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: "name"
      }, "Name *"), /*#__PURE__*/_react.default.createElement("input", {
        type: "text",
        id: "name",
        name: "name",
        className: "form-control input-lg",
        value: state.name,
        onChange: this.fieldChanged
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: "phone"
      }, "Phone number *"), /*#__PURE__*/_react.default.createElement("input", {
        type: "text",
        id: "phone",
        name: "phone",
        className: "form-control input-lg",
        value: state.phone,
        onChange: this.fieldChanged
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: "email"
      }, "Email address *"), /*#__PURE__*/_react.default.createElement("input", {
        type: "text",
        name: "email",
        id: "email",
        className: "form-control input-lg",
        value: state.email,
        onChange: this.fieldChanged
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: "facility"
      }, "Property / Facility name"), /*#__PURE__*/_react.default.createElement("input", {
        type: "text",
        name: "facility",
        id: "facility",
        className: "form-control input-lg",
        value: state.facility,
        onChange: this.fieldChanged
      })),
      /* <div className='form-group'>
      <label htmlFor='comments'>Comments</label>
      <textarea id='comments' name='comments' className='form-control input-lg' rows='3' value={state.comments} onChange={this.fieldChanged}></textarea>
      </div> */
      "", /*#__PURE__*/_react.default.createElement("div", {
        className: "form-action center-block"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "submit",
        className: 'btn btn-primary' + (this.state.status == 'submit' ? ' spinning' : ''),
        "data-spin": "true",
        disabled: !this.canSubmit()
      }, "Submit")));
    }
  }, {
    key: "canSubmit",
    value: function canSubmit() {
      return this.state.name.trim() && this.state.phone.trim() && this.state.email.trim() && EmailValidatorRegex.test(this.state.email) && this.state.status == 'form';
    }
  }]);
  return RequestAccess;
}(_react.Component), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "modal", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "fieldChanged", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "fieldChanged"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "submit", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "submit"), _class.prototype)), _class);
exports.RequestAccess = RequestAccess;
var instance = new RequestAccessModal();
var _default = instance;
exports.default = _default;